import styled from 'styled-components'

export const SortButtonContainer = styled.div`  
  display: grid;
  place-items: center;
  height: 16px;
  width: 16px;
  user-select: none;

  &:hover {
    border-radius: 50%;   
    background: rgba(32, 32, 32, 0.05);
  }
`

export const SortingArrowWrapper = styled.div`
  display: flex;
  gap: 8px;
`


